import { useMutation } from '@tanstack/react-query';

import { TSegment } from '@/features/segments/types';
import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';

import { invalidateProgramBroadcastWindow } from './invalidate-program-broadcast-window';

export function patchBroadcastScheduleProgramSegment({
  id,
  action,
}: {
  id: string;
  action: 'previous' | 'next';
}): Promise<TSegment> {
  return mediaManagerClient
    .patch(`/api/v1/program_broadcasts/${id}/segments/${action}`)
    .then(res => res.data[0]);
}

type MutationFn = typeof patchBroadcastScheduleProgramSegment;

type TUsePatchBroadcastScheduleProgramSegmentParams = {
  config?: MutationConfig<MutationFn>;
};

export function usePatchBroadcastScheduleProgramSegment({
  config = {},
}: TUsePatchBroadcastScheduleProgramSegmentParams = {}) {
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: patchBroadcastScheduleProgramSegment,
    onError(error, variables, context) {
      config.onError?.(error, variables, context);
      console.error(error);

      addErrorNotification('No se ha podido crear el segmento del programa');
    },
    onSuccess(data, variables, context) {
      config.onSuccess?.(data, variables, context);

      if (!data) {
        if (variables.action === 'previous') {
          addErrorNotification('No se encontraron segmentos anteriores');
        } else if (variables.action === 'next') {
          addErrorNotification('No se encontraron segmentos posteriores');
        }
      } else {
        addSuccessNotification('El segmento del programa se ha creado correctamente');
      }

      invalidateProgramBroadcastWindow(variables.id);
    },
  });
}
